'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRouter = require('react-router');
var _reduxPagan = require('redux-pagan');
var _reactRedux = require('react-redux');

var _components = require('../../components');
var _OMTitle = require('../../components/OMComponents/OMTitle/OMTitle');var _OMTitle2 = _interopRequireDefault(_OMTitle);

var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _constants = require('../../constants');
var _multiLanguageHeadTags = require('../../helpers/multiLanguageHeadTags');var _multiLanguageHeadTags2 = _interopRequireDefault(_multiLanguageHeadTags);
var _renderConfig = require('./renderConfig');var _renderConfig2 = _interopRequireDefault(_renderConfig);

var _PrivacyPolicyPage = require('../PrivacyPolicyPage/PrivacyPolicyPage.scss');var styles = _interopRequireWildcard(_PrivacyPolicyPage);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var TermsOfUsePage = function (_Component) {_inherits(TermsOfUsePage, _Component);function TermsOfUsePage() {var _temp, _this, _ret;_classCallCheck(this, TermsOfUsePage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.


    handleSelect = function (key) {
      if (key === _constants.privacyTermsTabs.PRIVACY) {
        _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/privacy' + (_this.props.isNative ? '?native=true' : '')));
      }
    }, _this.

    renderSubItem = function (translationTemplate, key) {return (
        _react2.default.createElement('li', {
          key: key,
          dangerouslySetInnerHTML: { __html: translationTemplate } }));}, _this.



    renderItem = function (itemId) {var subItemsCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;var subSubItems = arguments[2];var primary = arguments[3];
      var subItems = [];

      for (var idx = 1; idx <= subItemsCount; idx += 1) {
        var key = itemId + '.' + idx;
        var subItem = {};

        if (subSubItems && subSubItems.count && subSubItems.forSubItem === idx) {
          subItem = _this.renderItem(key, subSubItems.count, subSubItems);
        } else {
          subItem = _this.renderSubItem(_this.props.translate(key), key);
        }

        subItems.push(subItem);
      }

      return (
        _react2.default.createElement('li', { key: itemId },
          primary ?
          _react2.default.createElement('strong', { dangerouslySetInnerHTML: { __html: _this.props.translate(itemId) } }) :
          _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: _this.props.translate(itemId) } }),

          _react2.default.createElement('ol', null,
            subItems)));



    }, _this.

    renderContent = function () {return _renderConfig2.default.map(function (item) {return (
          _this.renderItem(item.itemId, item.subItems.count, item.subItems.subSubItems, true));});}, _temp), _possibleConstructorReturn(_this, _ret);}TermsOfUsePage.prototype.componentDidMount = function componentDidMount() {this.parenthesis.innerHTML = this.props.translate('parenthesis');};TermsOfUsePage.prototype.

  render = function render() {var _this2 = this;var _props =
    this.props,route = _props.route,locale = _props.locale;
    var multiLanguage = (0, _multiLanguageHeadTags2.default)(route, locale);

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.main_block, 'pageHeight') },
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.content, styles.onlyHe) },
          _react2.default.createElement(_reactHelmet2.default, {
            titleTemplate: this.props.staticTranslates('title', 'titleTemplate')(),
            title: this.props.staticTranslates('title', 'terms')(),
            meta: [
            { property: 'og:url', content: '' + _constants.shareUrl + route },
            {
              property: 'og:title',
              content: this.props.staticTranslates('footer', 'terms') + ' | \u202BOnMap' },

            { property: 'og:description', content: this.props.staticTranslates('helmet', 'termsDescription') },
            { name: 'description', content: this.props.staticTranslates('helmet', 'termsDescription') }],

            link: [].concat(
            multiLanguage, [
            { rel: 'canonical', href: '' + _constants.shareUrl + route }]) }),



          _react2.default.createElement(_components.OMTabs, {
              defaultActiveTabKey: _constants.privacyTermsTabs.TERMS,
              onSelect: this.handleSelect,
              id: 'terms-of-use',
              className: 'PrivacyTermsTabs' },

            _react2.default.createElement(_components.OMTab, { id: _constants.privacyTermsTabs.TERMS, title: '' + this.props.staticTranslates('footer', 'terms') },
              !this.props.isMobile && !this.props.isNative &&
              _react2.default.createElement(_OMTitle2.default, { className: 'pageTitle', title: this.props.staticTranslates('footer', 'terms') }),

              _react2.default.createElement('p', { style: { textAlign: 'right', direction: 'rtl' }, ref: function ref(parenthesis) {_this2.parenthesis = parenthesis;} }),
              _react2.default.createElement('ol', { style: { direction: 'rtl' } },
                this.renderContent())),


            _react2.default.createElement(_components.OMTab, { id: _constants.privacyTermsTabs.PRIVACY, title: '' + this.props.staticTranslates('footer', 'privacy') })))));




  };return TermsOfUsePage;}(_react.Component);


TermsOfUsePage.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  translate: _propTypes2.default.func.isRequired,
  staticTranslates: _propTypes2.default.func.isRequired,
  route: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  isNative: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'terms'),
    staticTranslates: (0, _reduxPagan.getLang)(state.lang, 'static') };};exports.default =


(0, _reactRedux.connect)(mapStateToProps)(
TermsOfUsePage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/TermsOfUsePage/TermsOfUsePage.js
// module id = 3110
// module chunks = 0